import { USER_INFO_URL } from 'constants/serviceUrl';
import { IUser } from 'models/global';
import { IRequestConfig, postRequest } from 'utils/request';

/* user */
export function getUserInfo(config?: Partial<IRequestConfig>) {
  return postRequest<{ user: IUser }>(USER_INFO_URL, {}, config);
}
